<template>
  <router-link v-if="route" :to="route" :target="target" :tabindex="tabindex" class="po-route-link">
    <wo-link tag-name="span" :class="linkClass">{{ routeLabel }}</wo-link>
  </router-link>
</template>
<script>

import _ from 'lodash'
import { findRoute } from '@/router'

export default {
  name: 'PoRouteLink',
  props: {
    value: [Object, String],
    label: String,
    labelKey: String,
    newWindow: Boolean,
    tabindex: [String, Number],
    linkClass: String
  },
  computed: {
    target () {
      return this.newWindow ? '_blank' : undefined
    },
    route () {
      return _.isString(this.value) ? { name: this.value } : Object.assign({}, this.value)
    },
    routeLabel () {
      return this.label || (this.labelKey ? this.$t(this.labelKey) : this.getLabelFromRoute())
    }
  },
  methods: {
    getLabelFromRoute () {
      let resolved
      if (this.route.meta) {
        resolved = this.route
      } else {
        resolved = findRoute(this.route.name)
      }

      return resolved && resolved.meta && resolved.meta.titleKey && this.$t(resolved.meta.titleKey)
    }
  }
}
</script>
<style lang="scss">
.wo-dropdown__links .po-route-link {
  &:hover , &:active, &:focus {
    text-decoration: none;
  }
}
</style>
